import getBindedLocalSelectors from "utils/getBindedLocalSelectors";
import getSelectors, { getVal, getValToArray } from "utils/getSelectors";
import local from "./local";

export default function selectorsGen(storeShape = { clients: ["clients"] }) {
  const storePath = storeShape.clients;

  const local$ = getBindedLocalSelectors(local, storePath);

  const basicSelectors = getSelectors({
    started$$: [local$.started, getVal],
    savedClients$$: [local$.savedClients, getValToArray],
    currentClient$$: [
      local$.currentClientId,
      local$.savedClients,
      (currentClientId, savedClients) => savedClients.get(currentClientId),
    ],
    // possibleClients$$: [
    //   local$.possibleClients,
    //   (possibleClients) => possibleClients.toArray(),
    // ],
    oktellSync$$: [local$.oktellSync, getVal],
    oktellSyncStateChanges$$: [local$.oktellSyncStateChanges, getVal],
    calls$$: [local$.calls, getVal],
    callsArray$$: [local$.calls, getValToArray],
    currentCallId$$: [local$.currentCall, getVal],
    mostRecentCallId$$: [local$.mostRecentCall, getVal],
    showCallInfo$$: [local$.showCallInfo, getVal],
    sdRequestLoading$$: [local$.sdRequestLoading, getVal],
    sdRequestCompleted$$: [local$.sdRequestCompleted, getVal],
    sdRequestError$$: [local$.sdRequestError, getVal],
  });

  const complexSelectors = getSelectors({
    currentCall$$: [
      basicSelectors.calls$$,
      basicSelectors.currentCallId$$,
      (calls, currentCallId) => {
        return calls.get(currentCallId);
      },
    ],
    mostRecentCall$$: [
      basicSelectors.calls$$,
      basicSelectors.mostRecentCallId$$,
      (calls, mostRecentCallId) => {
        return calls.get(mostRecentCallId);
      },
    ],
    selectedPerson$$: [
      basicSelectors.currentClient$$,
      (currentClient) => {
        return currentClient && currentClient.type === "PERSON"
          ? currentClient.toObject()
          : null;
      },
    ],
    selectedCompany$$: [
      basicSelectors.currentClient$$,
      (currentClient) => {
        return currentClient && currentClient.type === "COMPANY"
          ? currentClient.toObject()
          : null;
      },
    ],
    selectedClientType$$: [
      basicSelectors.currentClient$$,
      (currentClient) => {
        return currentClient && currentClient.type ? currentClient.type : null;
      },
    ],
    currentClientPrivileges$$: [
      basicSelectors.currentClient$$,
      (currentClient) => {
        return currentClient && currentClient.privileges
          ? currentClient.privileges.toObject()
          : null;
      },
    ],
  });

  return {
    ...basicSelectors,
    ...complexSelectors,
  };
}



// WEBPACK FOOTER //
// ./src/model/subsystems/clients/selectors/selectors.js